// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a3TableHeader_root_NEByI {
  margin: 0.938em 0;
  font-family: GothamRounded-Book;
  color: var(--timetable-text-color);
  break-after: avoid;
  margin: 0;
}

.a3TableHeader_root_NEByI.a3TableHeader_largerPaddingTop_QK3fw {
  padding-top: 0.25em;
}

.a3TableHeader_root_NEByI.a3TableHeader_noPaddingTop_Q5bIJ {
  margin: 0;
}

.a3TableHeader_strong_g0lso {
  font-family: GothamXNarrow-Medium;
  font-size: 1.115em;
}

.a3TableHeader_title_TRzkN {
  padding: 0.313em 0.45em;
  font-size: 1.05em;
  font-family: GothamXNarrow-Book;
}

.a3TableHeader_subtitle_Q6VNL {
  display: flex;
  padding: 0 0.625em 0 0.65em;
  font-size: 0.75em;
  line-height: 1.2;
  letter-spacing: -0.025em;
  align-items: center;
}

.a3TableHeader_subtitleContent_WDNfj {
  padding-left: 5px;
}

.a3TableHeader_subtitleContentExtraPadding_dn8yn {
  padding-left: 10px;
}

.a3TableHeader_a3Title_tafkH {
  font-size: 0.8em;
}

.a3TableHeader_timeLogo_HXUBx {
  height: 30px;
  width: 30px;
}

.a3TableHeader_italics_wkxoG {
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/a3Timetable/a3TableHeader.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".root {\n  margin: 0.938em 0;\n  font-family: GothamRounded-Book;\n  color: var(--timetable-text-color);\n  break-after: avoid;\n  margin: 0;\n}\n\n.root.largerPaddingTop {\n  padding-top: 0.25em;\n}\n\n.root.noPaddingTop {\n  margin: 0;\n}\n\n.strong {\n  font-family: GothamXNarrow-Medium;\n  font-size: 1.115em;\n}\n\n.title {\n  padding: 0.313em 0.45em;\n  font-size: 1.05em;\n  font-family: GothamXNarrow-Book;\n}\n\n.subtitle {\n  display: flex;\n  padding: 0 0.625em 0 0.65em;\n  font-size: 0.75em;\n  line-height: 1.2;\n  letter-spacing: -0.025em;\n  align-items: center;\n}\n\n.subtitleContent {\n  padding-left: 5px;\n}\n\n.subtitleContentExtraPadding {\n  padding-left: 10px;\n}\n\n.a3Title {\n  font-size: 0.8em;\n}\n\n.timeLogo {\n  height: 30px;\n  width: 30px;\n}\n\n.italics {\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `a3TableHeader_root_NEByI`,
	"largerPaddingTop": `a3TableHeader_largerPaddingTop_QK3fw`,
	"noPaddingTop": `a3TableHeader_noPaddingTop_Q5bIJ`,
	"strong": `a3TableHeader_strong_g0lso`,
	"title": `a3TableHeader_title_TRzkN`,
	"subtitle": `a3TableHeader_subtitle_Q6VNL`,
	"subtitleContent": `a3TableHeader_subtitleContent_WDNfj`,
	"subtitleContentExtraPadding": `a3TableHeader_subtitleContentExtraPadding_dn8yn`,
	"a3Title": `a3TableHeader_a3Title_tafkH`,
	"timeLogo": `a3TableHeader_timeLogo_HXUBx`,
	"italics": `a3TableHeader_italics_wkxoG`
};
module.exports = ___CSS_LOADER_EXPORT___;
